export function excerptTrimmer(string, maxLength){
  let wordTrimmed = string

  if(string && string.length > maxLength){
    const charTrimmed = string && string.length > maxLength ? string.slice(0, maxLength) : string
    const splittedByWords = charTrimmed.split(' ')
    wordTrimmed = splittedByWords.slice(0, splittedByWords.length-1).join(' ')+'...'
  }

  return wordTrimmed
}
